import {
  CONTRACT_GET_SUCCESS,
  CONTRACT_GET_FAIL,
  LOGOUT
} from "../actions/types";


export default function (state = {current:null }, action) {
  const { type, payload } = action;
  //console.log(payload)
  switch (type) {
    case CONTRACT_GET_SUCCESS:
      return {
        current: payload
      };
    case CONTRACT_GET_FAIL:
      return state;
      case LOGOUT:
      return {
        current: null,
      };
    default:
      return state;
  }
}
